import ShapeBase from './ShapeBase';
import entity from '../assets/icons/entity.svg';
import { svgToIcon } from '../utils/svg';
import type Shape from '../objects/Shape';

class ShapeEntity extends ShapeBase {
  constructor(fabricObject: Shape) {
    super(fabricObject);

    // Set min scale to avoid drawing top line outside of shape
    fabricObject.minScaleLimit = (this.offset() / 100) * 2.5;
  }

  static renderIcon() {
    return svgToIcon(entity);
  }

  offset() {
    return 30;
  }

  calcTextMargin() {
    return {
      top: this.offset() + 5,
      left: 5,
      right: 5,
      bottom: 5,
    };
  }

  render(ctx: CanvasRenderingContext2D) {
    const obj = this.fabricObject;
    const { width: w, height: h } = obj;
    const topLine = -h / 2 + this.verticalOffset();

    ctx.beginPath();
    this._setBorderDash(ctx);

    ctx.moveTo(-w / 2, -h / 2);
    ctx.lineTo(w / 2, -h / 2);
    ctx.lineTo(w / 2, h / 2);
    ctx.lineTo(-w / 2, h / 2);
    ctx.lineTo(-w / 2, h / 2);
    ctx.closePath(); // close path to avoid issue with thick borders
    ctx.moveTo(-w / 2, topLine);
    ctx.lineTo(w / 2, topLine);
    ctx.closePath();

    obj._renderPaintInOrder(ctx);
  }
}

export default ShapeEntity;
